export const UserActionTypes = {
  SET_LANGUAGE: 'SET_LANGUAGE',
};

export const setLanguage = (language) => ({
  type: UserActionTypes.SET_LANGUAGE,
  language,
});
